module.exports = __webpack_public_path__ + "img/email.5bdd1bf3.svg";